<template>
    <div :class="{'list-view' : heading }">
    <div v-if="heading" class="row titleBar">
        <h1>{{ heading }}</h1>
        <div id="top_right_buttons">
            <button class="btn btn-sm btn-create" v-on:click.prevent="$root.createDialog('emailaccount')">
                <i class="icon icon-lg icon-create-circle"></i> Create Account</button>
        </div>
    </div><!-- .titleBar -->
    <div v-show="accounts.length > 0" class="panel email-list">
        <div class="panel-heading">
            <div class="row">
                <div class="col-md-5"><strong>Email Accounts</strong></div>
                <div class="col-md-3"><strong>Company</strong></div>
                <div class="col-md-1"><strong>Server</strong></div>
                <div class="col-md-2"><strong>Tags</strong></div>
                <div class="col-md-1"></div>
            </div>
        </div><!-- .panel-heading -->
        <div class="panel-body">
            <div class="link-contain" v-for="acc in accounts">
                <div class="row top-level" @click="toggle('#accountPanel' + acc.public_id)">
                    <div class="col-md-5">
                        <i v-if="!acc.suspended && acc.server_id != '0'" class="icon icon-ctrl icon-right"></i><a>
                        <strong>{{ acc.domain }}</strong></a>
                        <span v-if="acc.suspended" class="error" :title="acc.suspended">Suspended</span>
                    </div>
                    <div class="col-md-3"><div v-if="acc.company"><a :href="'/company/' + acc.company.public_id">{{ acc.company.name }}</a></div></div>
                    <div class="col-md-1">{{ getServerType(acc) }}</div>
                    <div class="col-md-2">{{ acc.tags }}</div>
                    <div class="col-md-1"><a @click.stop="viewLoader('/api/email/account/' + acc.public_id, $event)"><i class="icon icon-edit"></i> Edit</a> </div>
                </div>
                <div v-if="!acc.suspended && acc.server_id != '0'" class="collapse" :id="'accountPanel' + acc.public_id">
                    <div class="email-accounts">
                        <div class="row second-level" @click.prevent="toggle('#email-' + acc.public_id)">
                            <i class="icon icon-ctrl icon-right"></i>
                            <span class="number">{{ datcount('email', acc.public_id) }}</span>
                             Emails
                            <a v-on:click="addEmail(acc.public_id, acc.domain)" type="button" class="btn-create">
                                <i class="icon icon-lg icon-create-circle"></i></a>
                        </div>
                        <div class="collapse" :id="'email-' + acc.public_id">
                            <datatable parent="0" :data='data(acc, "address")'></datatable>
                        </div>
                    </div><!-- .email-accounts -->
                    <div class="email-forward">
                        <div class="row second-level" @click.prevent="toggle('#forwarder-' + acc.public_id)">
                            <i class="icon icon-ctrl icon-right"></i>
                            <span class="number">{{ datcount('forward', acc.public_id) }}</span>
                            Forwarders
                            <a v-on:click="addFwd(acc.public_id, acc.domain)" type="button" class="btn-create">
                                <i class="icon icon-lg icon-create-circle"></i></a>
                        </div>
                        <div class="collapse" :id="'forwarder-' + acc.public_id">
                            <datatable parent="0" :data='data(acc, "forwarder")'></datatable>
                        </div>
                    </div><!-- .email-forward -->
                    <div class="email-respond">
                        <div class="row second-level" @click.prevent="toggle('#respond-' + acc.public_id)">
                            <i class="icon icon-ctrl icon-right"></i>
                            <span class="number">{{ datcount('respond', acc.public_id) }}</span>
                            Autoresponders
                            <a v-on:click="$root.createDialog('autoresponder', { id: acc.public_id, domain: acc.domain})" type="button" class="btn-create">
                                <i class="icon icon-lg icon-create-circle"></i>
                            </a>
                        </div>
                        <div class="collapse" :id="'respond-' + acc.public_id">
                            <datatable parent="0" :data='data(acc, "responder")'></datatable>
                        </div>
                    </div><!-- .email-respond -->
                </div><!-- .collapse -->
            </div><!-- .link-contain -->
        </div><!-- .panel-body-->
    </div><!-- .panel.email-list -->
    <div v-show="!accounts.length" class="email-empty">Nothing here yet. Click on the green plus icon to start creating now.</div>
    </div><!-- .list-view -->
</template>
<script>
    export default{
        props: {
            heading: { default: '' },
            accounts: { default: [] }
        },
        mixins: [ require('../methods/email.js') ],
        created() {
            this.$eventHub.$on('create', this.setupMail);
            if (this.accounts.length) {
                let count = {};
                $.each(this.accounts, function (key, value) {
                    count['email' + value.public_id] = 'N/A';
//                    this.$eventHub.$on('create', this.setupMail);
                    count['email' + value.public_id] = 'N/A';
                    count['respond' + value.public_id] = 'N/A';
                    count['forward' + value.public_id] = 'N/A';
                })
                this.count = count;
            }
        },
        data(){
            return {
                count: {}
            }
        },
        components: {
            'datatable': require('../components/datatable.vue').default,
            'company': require('../components/autocomplete/company.vue').default,
            'domain-ls': require('../components/domain-ls.vue').default
        },
        methods: {
            getServerType(acc){
                if (acc.server_id != '0') {
                    return acc.server.name;
                } else {
                    return acc.server_type;
                }
            },
            datcount: function(entity, id) {
                if(typeof this.count[entity + id] !== 'undefined'){
                    return this.count[entity + id];
                }
                return 0;
            },
            viewLoader: function (url, event) {
                this.$eventHub.$emit('viewLoader', url, event);
            },
            county: function (tar) {
                return tar + 'i';
            },
            // Generate an ID and URL for the Datatable
            data: function (acc, type) {
                return {
                    "id": acc.public_id + '-' + type,
                    "url": "\/email\/" + type + "\/" + acc.public_id
                };
            },
            // Toggle Panel Collapse
            toggle: function (panel) {
                myToggle(panel); // FUCK VUE
            }
        }
    }
</script>
